import {MajorGameEventTemplateAnimationSetModel} from "../../templates/major-game-event-template-animation-set-model";
import {AnimationLogoGoalEventRequestParams} from "../../animation-logo-goal-event-request-params";

export class BaseGoalAnimationSetModel extends MajorGameEventTemplateAnimationSetModel {
  get eventLogo(): AnimationLogoGoalEventRequestParams {
    return new AnimationLogoGoalEventRequestParams(this.id, this.isHomeCompetitor);
  }
}